// extracted by mini-css-extract-plugin
export default {"image":"styles_image__JKwDQ","content":"styles_content__s348U","content2":"styles_content2__uT9km","content3":"styles_content3__DA9qK","more":"styles_more__yjpfl"};